import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Stat from './Stat';
var USER_ID_COOKIE_NAME = 'ajs_user_id';
var ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
var STATE = {
  handlers: [],
  workerCreationIsInProgress: false,
  worker: undefined,
  workerDiedTimes: 0
};
export function identify(statHandler, apiKey, user) {
  Stat.identify(statHandler, apiKey, user);
}
export function track(statHandler, apiKey, event, properties, flags) {
  Stat.track(statHandler, apiKey, event, properties, flags);
}
export function trackBatch(statHandler, apiKey, events, flags) {
  Stat.trackBatch(statHandler, apiKey, events, flags);
}
export function page(statHandler, apiKey, properties, flags) {
  Stat.page(statHandler, apiKey, properties, flags);
}
export function clearBatches(statHandler) {
  Stat.clearBatches(statHandler);
}
export function flushBatches(statHandler) {
  Stat.flushBatches(statHandler);
}
export function flushBatch(statHandler, apiKey) {
  Stat.flushBatch(statHandler, apiKey);
}
export function createStatHandler(options) {
  var _options$batches;

  var statHandler = Stat.createStatHandler({
    apiHost: options.apiHost,
    library: options.library,
    version: options.version,
    batches: options.batches,
    app: {
      getStoredUserIds: getStoredUserIds,
      storeUserIds: storeUserIds,
      addCommonStatParams: function addCommonStatParams(params) {
        return options.addCommonStatParams(params);
      },
      getStatContextPage: getStatContextPage,
      getUserAgent: getUserAgent,
      sendError: options.sendError
    }
  });
  var allowWorker = !!options.worker;

  if (allowWorker && window.Worker) {
    tryCreateStatsWorker(STATE, options);
  }

  if ((_options$batches = options.batches) !== null && _options$batches !== void 0 && _options$batches.flushInterval) {
    statHandler.flushBatchesIntervalId = window.setInterval(function () {
      flushBatches(statHandler);
    }, options.batches.flushInterval);
  }

  STATE.handlers.push(statHandler);
  return statHandler;
}
export function destroyStatHandler(statHandler) {
  clearInterval(statHandler.flushBatchesIntervalId);
  statHandler.flushBatchesIntervalId = undefined;
  Stat.destroyStatHandler(statHandler);
}

function tryCreateStatsWorker(state, options) {
  if (!state.worker && !state.workerCreationIsInProgress && options.worker) {
    state.workerCreationIsInProgress = true;

    if (state.workerDiedTimes > 5) {
      options.sendError('Stats worker dies too often', {
        count: state.workerDiedTimes
      });

      if (state.workerDiedTimes > 10) {
        // NOTE: here we just forget about worker, it dies too often.
        // We keep _workerCreationIsInProgress_ flag
        // forever so no one will be able to create it again
        return;
      }
    }

    var workerUrl = options.worker.url;

    var _weAreOnCDN = options.weAreOnCDN ? options.weAreOnCDN() : false;

    if (_weAreOnCDN) {
      // We need to use this workaround to be able to specify origin.
      // https://stackoverflow.com/a/60252783
      var workerBlob = new Blob(['importScripts(' + JSON.stringify(workerUrl) + ')'], {
        type: 'application/javascript'
      });
      workerUrl = window.URL.createObjectURL(workerBlob);
    }

    var cleanUpAndTryToRestartWebWorker = function cleanUpAndTryToRestartWebWorker(message, error) {
      state.workerDiedTimes++;

      if (message) {
        error = error || 'Unknown';

        var _extra = typeof error === 'string' ? error : getMessageFromWorkerError(error);

        var customError = new Error(message);
        options.sendError(customError, _extra);
      }

      if (_weAreOnCDN) {
        window.URL.revokeObjectURL(workerUrl);
      }

      tryCreateStatsWorker(state, options);
    };

    var createWorkerPromise = function createWorkerPromise() {
      return new Promise(function (resolve, reject) {
        var worker = new Worker(workerUrl, {
          name: 'StatsWorker'
        });
        var timeoutId = setTimeout(function () {
          return reject(new Error('timeout'));
        }, 10000);

        var onInitError = function onInitError(error) {
          worker.terminate();
          reject(error);
        };

        var onReady = function onReady(event) {
          if (event.data === 'ready') {
            clearTimeout(timeoutId);
            worker.removeEventListener('message', onReady);
            worker.removeEventListener('error', onInitError);
            worker.addEventListener('error', function (error) {
              worker.terminate();
              state.handlers.forEach(function (handler) {
                handler.worker = undefined;
              });
              state.worker = undefined;
              cleanUpAndTryToRestartWebWorker('Stats worker died 2', error);
            });
            var statWorker = createStatWorker(worker);
            state.handlers.forEach(function (handler) {
              handler.worker = statWorker;
            });
            state.worker = worker;
            state.workerCreationIsInProgress = false;
            resolve();
          }
        };

        worker.addEventListener('message', onReady);
        worker.addEventListener('error', onInitError);
      });
    };

    var workerPromise;

    if (options.retryPromise) {
      workerPromise = options.retryPromise(createWorkerPromise, {
        maxTries: 5,
        retryTimeout: 3000,
        increaseTimeoutFactor: 1,
        maxRetryTimeout: 5000,
        logErrorsToConsole: true,
        waitUntilOnline: true
      });
    } else {
      workerPromise = createWorkerPromise();
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any


    workerPromise["catch"](function (error) {
      // NOTE: we don't care about init errors. We logged them previously,
      // but they were just eating space in errors tracker system
      cleanUpAndTryToRestartWebWorker();
    });
  }
}

function createStatWorker(worker) {
  return {
    postMessage: function postMessage(data) {
      switch (data.event) {
        case 'track':
          {
            var _data$payload$propert;

            var bufferData = (_data$payload$propert = data.payload.properties) === null || _data$payload$propert === void 0 ? void 0 : _data$payload$propert.__bufferData;

            if (bufferData && bufferData.transferables) {
              worker.postMessage(data, bufferData.transferables);
            } else {
              worker.postMessage(data);
            }
          }
          break;

        case 'trackBatch':
          {
            var transferables = [];
            data.payload.tracks.forEach(function (track) {
              var _track$properties;

              var bufferData = (_track$properties = track.properties) === null || _track$properties === void 0 ? void 0 : _track$properties.__bufferData;

              if (bufferData && bufferData.transferables) {
                transferables = transferables.concat(bufferData.transferables);
              }
            });
            worker.postMessage(data, transferables);
          }
          break;

        default:
          {
            worker.postMessage(data);
          }
          break;
      }
    }
  };
}

function getMessageFromWorkerError(error) {
  var message;

  try {
    message = "Message: ".concat(error.message, ". Filename: ").concat(error.filename, ". Colno: ").concat(error.colno, ". Rowno: ").concat(error.lineno, ". Error: ").concat(String(error.error));
  } catch (e) {
    message = "Failed to create message";
  }

  return message;
}

function getStoredUserIds() {
  var cookie = document.cookie;
  var anonymousId = getCookieFrom(ANONYMOUS_ID_COOKIE_NAME, cookie);

  if (anonymousId) {
    anonymousId = anonymousId.replace(/"/g, '');
  } else {
    anonymousId = undefined;
  }

  var userId = getCookieFrom(USER_ID_COOKIE_NAME, cookie);

  if (userId) {
    userId = userId.replace(/"/g, '');
  } else {
    userId = undefined;
  } // NOTE: analytics.js writes "null" as a string to cookies..


  if (userId === 'null') {
    userId = undefined;
  }

  if (userId === 'undefined') {
    userId = undefined;
  }

  return {
    userId: userId,
    anonymousId: anonymousId
  };
}

function storeUserIds(userIds) {
  var date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  setCookie(ANONYMOUS_ID_COOKIE_NAME, "\"".concat(userIds.anonymousId, "\""), {
    expires: date,
    path: '/'
  });

  if (userIds.userId) {
    setCookie(USER_ID_COOKIE_NAME, "\"".concat(userIds.userId, "\""), {
      expires: date,
      path: '/'
    });
  } else {
    deleteCookie(USER_ID_COOKIE_NAME, {
      path: '/'
    });
  }
}

function getStatContextPage(statHandler) {
  var context = {
    referrer: document.referrer,
    path: location.pathname,
    title: document.title,
    url: location.href,
    search: location.search,
    site_language: document.getElementsByTagName('html')[0].getAttribute('lang') || 'en',
    inIframe: inIframe()
  };
  return context;
}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    // blocked by cors
    return true;
  }
}

function getUserAgent() {
  return navigator.userAgent;
}

function getCookieFrom(name, cookieString) {
  var matches = cookieString.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
  var expires = options.expires;

  if (typeof expires === 'string') {// noop
  } else {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);
  var updatedCookie = name + '=' + value;

  for (var propName in options) {
    updatedCookie += '; ' + propName;
    var propValue = options[propName];

    if (propValue !== true) {
      updatedCookie += '=' + propValue;
    }
  }

  document.cookie = updatedCookie;
}

function deleteCookie(name, options) {
  setCookie(name, '', _objectSpread(_objectSpread({}, options), {}, {
    expires: 'Thu, 01 Jan 1970 00:00:01 GMT'
  }));
}